import store from '../store';
import Constants from './constants';
import Vue from 'vue';
import router from '../router';

const utils = {
    isMobile() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            return true;
        }

        return false;
    },
    formatOdds(odds, precision = 3) {
        if (!odds) {
            return '';
        }

        let oddsArr = (odds + '').split('.');
        return oddsArr[0] + '.' + (oddsArr[1] ? oddsArr[1].slice(0, precision).padEnd(precision, '0') : ''.padStart(precision, '0'));
    },
    getCurrencySymbol: function (currency_id) {
        return Constants.CURRENCY[currency_id];
    },
    getStrDate: function (seconds) {
        let str = '';
        let one_day = 60 * 60 * 24;
        let one_hour = 60 * 60;
        let one_min = 60;
        let h = '',
            m = '';
        let d = Math.floor(seconds / one_day);
        if (d > 0) {
            str += d + 'd ';
            h = Math.floor((seconds - d * one_day) / one_hour);
        } else {
            h = Math.floor(seconds / one_hour);
        }
        seconds = seconds - (d * one_day + h * one_hour);
        if (h > 0) {
            str += h + 'h ';
        } else {
            str += '0h ';
        }

        if (seconds > 0) {
            m = Math.floor(seconds / one_min);
        } else {
            m = 0;
        }
        str += m + 'm';

        return str;
    },
    getDateRemaining: function (leftUntilStart) {
        let diff = '- ';

        if (leftUntilStart < 1) {
            diff = store.$i18n.t('common.live');
        } else {
            let days = Math.floor(leftUntilStart / (60 * 24));
            let hour = Math.floor((leftUntilStart % (60 * 24)) / 60);
            let minutes = Math.floor((leftUntilStart % (60 * 24)) % 60);
            if (days) {
                diff += days + 'd ';
            }
            if (hour) {
                diff += hour + 'h ';
            }
            if (minutes) {
                diff += minutes + 'm ';
            }
        }

        return diff;
    },
    capitalizeFirstLetter: (string) => string[0].toUpperCase() + string.slice(1).toLowerCase(),
    capitalizeFirstOnlyLetter: (string) => string[0].toUpperCase() + string.slice(1),
    lowerCaseFirstOnlyLetter: (string) => string[0].toLowerCase() + string.slice(1),
    updateBreadcrumbs: function (currentLink) {
        let navMenuItems =
            this.getPlatform() === Constants.PLATFORM_TRADEBALL ? store.getters['MenuModule/getNavMenuItems'] : store.getters['MenuModule/getNavMenuItemsWL'];
        let breadCrumbs = [];

        navMenuItems.map(function (menuItem) {
            if (menuItem.subItems) {
                menuItem.subItems.map(function (subMenuItem) {
                    if (subMenuItem.link === currentLink) {
                        breadCrumbs.push({
                            text: menuItem.title,
                            disabled: false,
                        });

                        let title = subMenuItem.breadcrumb ? subMenuItem.breadcrumb : subMenuItem.title;
                        breadCrumbs.push({ text: title, disabled: false });
                    }
                });
            } else if (menuItem.link && menuItem.link === currentLink) {
                breadCrumbs.push({ text: menuItem.title, disabled: false });
            }
        });
        if (!breadCrumbs.length) {
            breadCrumbs.push({ text: currentLink, disabled: false });
        }

        store.commit('MenuModule/setBreadcrumbs', breadCrumbs);
    },
    hideTooltip: function (tooltipElId = 'tooltip') {
        let tooltip = document.getElementById(tooltipElId);
        if (tooltip) {
            tooltip.classList.remove('show');
        }
    },
    showTooltip: function (event, content, withYOffset = true, tooltipElId = 'tooltip') {
        if (!content) return;
        let tooltip = document.getElementById(tooltipElId);

        const menuHeight = 48; //px

        if (tooltip) {
            tooltip.classList.add('show');
            tooltip.innerHTML = content;
            tooltip.style.left = event.pageX - (event.target.dataset.tooltipPosition === 'left' ? tooltip.clientWidth : 0) + 'px';

            let yOffsetHeight = 0;

            if (withYOffset) {
                yOffsetHeight = event.srcElement.offsetHeight;
            }

            let top = event.pageY - yOffsetHeight;
            const contentHeight = tooltip.clientHeight;

            if (contentHeight + menuHeight > top) {
                top = contentHeight + menuHeight;
            }

            tooltip.style.top = top + 'px';
        }
    },
    isEditAction: function (index) {
        return index > -1;
    },
    isEmpty: function (v) {
        return !v && parseInt(v) !== 0;
    },
    isEmail: function (v) {
        return String(v)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    },
    isNumeric: function (v) {
        return /^-?\d+$/.test(v);
    },
    isValidNumber(value) {
        return value !== null && value !== undefined && !isNaN(parseFloat(value)) && isFinite(value);
    },
    formatNumber(value, format = null) {
        if (!format) {
            return value;
        }

        switch (format) {
            case 'money':
                return parseFloat(value)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,');
            default:
                return value;
        }
    },
    bettingInfoForMessage(bet, withStake = true, stakeFloat = 'float-end', withSite = false, withTeam = true) {
        let betInfo = '';
        let gameInfo = '';
        let score = '';
        let game = withTeam ? ' [' + store.$i18n.t('bet.game') + ']' : '';
        let period = bet.period_type_id === Constants.GAME_PERIOD_FT ? store.$i18n.t('order.periodFTAbbr') : store.$i18n.t('order.period1HAbbr');
        let handicap = parseFloat(bet.handicap).toFixed(2);
        let user = store.getters['UserModule/getUser'];

        if (handicap === '0.00') {
            handicap = 0;
        }

        let site = withSite ? '<span class="pr-1 bookmaker' + bet.site_id + '">' + Constants.SITE_CODE[bet.site_id] + '</span>' : '';

        let odds = ' @' + utils.formatOdds(bet.odds);

        let stake = '';

        if (withStake) {
            if (bet.status_id === Constants.BET_STATUS_SET && bet.balance) {
                const colorClass = bet.balance > 0 ? 'greenText' : bet.balance < 0 ? 'redText' : '';
                stake =
                    ' <span style="text-decoration: inherit;" class="' +
                    stakeFloat +
                    ' ' +
                    colorClass +
                    ' pr-1">' +
                    site +
                    utils.getCurrencySymbol(user.currency) +
                    parseFloat(bet.balance).toFixed(2) +
                    '</span>';
            } else if (bet.stake) {
                stake =
                    ' <span style="text-decoration: inherit;" class="' +
                    stakeFloat +
                    ' pr-1">' +
                    site +
                    utils.getCurrencySymbol(user.currency) +
                    parseFloat(bet.stake).toFixed(2) +
                    '</span>';
            }
        }

        if (bet.is_live) {
            if (
                bet.type === Constants.BET_TYPE_CORNERS_HANDICAP_JOLLY ||
                bet.type === Constants.BET_TYPE_CORNERS_HANDICAP_DOG ||
                bet.type === Constants.BET_TYPE_CORNERS_GOAL_OVER ||
                bet.type === Constants.BET_TYPE_CORNERS_GOAL_UNDER
            ) {
                score += '(' + (this.isValidNumber(bet.corners_home) ? bet.corners_home + '-' + bet.corners_away : store.$i18n.t('bet.NC')) + ')';
            } else {
                score = ' (' + (bet.score ? bet.score : store.$i18n.t('bet.NC')) + ')';
            }
        }

        if (bet.type === Constants.BET_TYPE_1X2_HOME) {
            betInfo = (withTeam ? '' : store.$i18n.t('bet.popup.home')) + odds;
            gameInfo =
                (withTeam ? '<div class="text-truncate panel-bet pr-1">' + bet.team_home_name + '</div>' : '') + (withTeam ? ' • ' + period : period) + '|1X2';
        } else if (bet.type === Constants.BET_TYPE_1X2_AWAY) {
            betInfo = (withTeam ? '' : store.$i18n.t('bet.popup.away')) + odds;
            gameInfo =
                (withTeam ? '<div class="text-truncate panel-bet pr-1">' + bet.team_away_name + '</div>' : '') + (withTeam ? ' • ' + period : period) + '|1X2';
        } else if (bet.type === Constants.BET_TYPE_1X2_DRAW) {
            betInfo = store.$i18n.t('bet.popup.draw') + odds;
            gameInfo =
                (withTeam ? '<div class="text-truncate panel-bet pr-1">' + bet.team_home_name + '</div>' : '') + (withTeam ? ' • ' + period : period) + '|1X2';
        } else if (bet.type === Constants.BET_TYPE_HANDICAP_JOLLY || bet.type === Constants.BET_TYPE_HANDICAP_DOG) {
            betInfo = (handicap > 0 ? '+' : '') + handicap + odds;
            gameInfo =
                '<div class="text-truncate panel-bet pr-1">' +
                (bet.teamwhere === Constants.TEAM_HOME ? bet.team_home_name : bet.team_away_name) +
                '</div>' +
                ' • ' +
                period +
                '|A/H';
        } else if (bet.type === Constants.BET_TYPE_CORNERS_HANDICAP_JOLLY || bet.type === Constants.BET_TYPE_CORNERS_HANDICAP_DOG) {
            betInfo = (handicap > 0 ? '+' : '') + handicap + odds;
            gameInfo =
                '<div class="text-truncate panel-bet pr-1">' +
                (bet.teamwhere === Constants.TEAM_HOME ? bet.team_home_name : bet.team_away_name) +
                '</div>' +
                ' • ' +
                period +
                '|' +
                store.$i18n.t('order.cornersHandicapAbbr');
        } else if (bet.type === Constants.BET_TYPE_GOAL_OVER) {
            betInfo = store.$i18n.t('betDialog.over') + ' ' + handicap + odds;
            gameInfo =
                (withTeam ? '<div class="text-truncate panel-bet pr-1">' + bet.team_home_name + '</div>' : '') +
                game +
                (withTeam ? ' • ' + period : period) +
                '|O/U';
        } else if (bet.type === Constants.BET_TYPE_GOAL_UNDER) {
            betInfo = store.$i18n.t('betDialog.under') + ' ' + handicap + odds;
            gameInfo =
                (withTeam ? '<div class="text-truncate panel-bet pr-1">' + bet.team_home_name + '</div>' : '') +
                game +
                (withTeam ? ' • ' + period : period) +
                '|O/U';
        } else if (bet.type === Constants.BET_TYPE_CORNERS_GOAL_OVER) {
            betInfo = store.$i18n.t('betDialog.over') + ' ' + handicap + odds;
            gameInfo =
                (withTeam ? '<div class="text-truncate panel-bet pr-1">' + bet.team_home_name + '</div>' : '') +
                game +
                (withTeam ? ' • ' + period : period) +
                '|' +
                store.$i18n.t('order.cornersGoalAbbr');
        } else if (bet.type === Constants.BET_TYPE_CORNERS_GOAL_UNDER) {
            betInfo = store.$i18n.t('betDialog.under') + ' ' + handicap + odds;
            gameInfo =
                (withTeam ? '<div class="text-truncate panel-bet pr-1">' + bet.team_home_name + '</div>' : '') +
                game +
                (withTeam ? ' • ' + period : period) +
                '|' +
                store.$i18n.t('order.cornersGoalAbbr');
        } else if (bet.type === Constants.BET_TYPE_BTTS_YES) {
            betInfo = store.$i18n.t('betDialog.bts') + ' - ' + store.$i18n.t('betDialog.yes') + odds;
            gameInfo =
                (withTeam ? '<div class="text-truncate panel-bet pr-1">' + bet.team_home_name + '</div>' : '') +
                game +
                (withTeam ? ' • ' + period : period) +
                '|' +
                store.$i18n.t('order.bts');
        } else if (bet.type === Constants.BET_TYPE_BTTS_NO) {
            betInfo = store.$i18n.t('betDialog.bts') + ' - ' + store.$i18n.t('betDialog.no') + odds;
            gameInfo =
                (withTeam ? '<div class="text-truncate panel-bet pr-1">' + bet.team_home_name + '</div>' : '') +
                game +
                (withTeam ? ' • ' + period : period) +
                '|' +
                store.$i18n.t('order.bts');
        } else if (bet.type === Constants.BET_TYPE_DC_HOME_OR_DRAW) {
            betInfo = store.$i18n.t('betDialog.home') + store.$i18n.t('betDialog.or') + store.$i18n.t('betDialog.draw') + odds;
            gameInfo =
                (withTeam ? '<div class="text-truncate panel-bet pr-1">' + bet.team_home_name + '</div>' : '') +
                game +
                (withTeam ? ' • ' + period : period) +
                '|' +
                store.$i18n.t('order.dc');
        } else if (bet.type === Constants.BET_TYPE_DC_HOME_OR_AWAY) {
            betInfo = store.$i18n.t('betDialog.home') + store.$i18n.t('betDialog.or') + store.$i18n.t('betDialog.away') + odds;
            gameInfo =
                (withTeam ? '<div class="text-truncate panel-bet pr-1">' + bet.team_home_name + '</div>' : '') +
                game +
                (withTeam ? ' • ' + period : period) +
                '|' +
                store.$i18n.t('order.dc');
        } else if (bet.type === Constants.BET_TYPE_DC_DRAW_OR_AWAY) {
            betInfo = store.$i18n.t('betDialog.draw') + store.$i18n.t('betDialog.or') + store.$i18n.t('betDialog.away') + odds;
            gameInfo =
                (withTeam ? '<div class="text-truncate panel-bet pr-1">' + bet.team_home_name + '</div>' : '') +
                game +
                (withTeam ? ' • ' + period : period) +
                '|' +
                store.$i18n.t('order.dc');
        } else if (bet.type === Constants.BET_TYPE_CS_CS) {
            betInfo = bet.correct_score + odds;
            gameInfo = '<div class="text-truncate panel-bet pr-1">' + bet.team_home_name + '</div>' + period + '|' + store.$i18n.t('order.cs');
        }

        betInfo += score + stake;

        return { betInfo: betInfo, gameInfo: gameInfo };
    },
    bettingInfoForTooltip(bet) {
        let betInfo = '';
        let gameInfo = '';
        let score = '';
        let market = '';
        let bookmaker = Constants.SITE_NAME[bet.site_id];
        let minute = bet.time ? ' ' + utils.getBetMinute(bet) + ' ' : ' ';
        // let betting = (bet.betOrderId ? store.$i18n.t('panel.orderBet') : store.$i18n.t('panel.botBet')) + ' ';
        let betType = '';
        let game = bet.team_home_name + ' vs ' + bet.team_away_name;

        let period = (bet.period_type_id === Constants.GAME_PERIOD_FT ? store.$i18n.t('panel.marketFT') : store.$i18n.t('panel.market1H')) + ' | ';
        let handicap = parseFloat(bet.handicap).toFixed(2);
        let user = store.getters['UserModule/getUser'];

        if (handicap === '0.00') {
            handicap = 0;
        }

        let odds = ' @' + utils.formatOdds(bet.odds);
        let stake = utils.getCurrencySymbol(user.currency) + parseFloat(bet.stake).toFixed(2);

        if (bet.is_live) {
            if (
                bet.type === Constants.BET_TYPE_CORNERS_HANDICAP_JOLLY ||
                bet.type === Constants.BET_TYPE_CORNERS_HANDICAP_DOG ||
                bet.type === Constants.BET_TYPE_CORNERS_GOAL_OVER ||
                bet.type === Constants.BET_TYPE_CORNERS_GOAL_UNDER
            ) {
                score += ' (' + (bet.corners_home !== null ? bet.corners_home + '-' + bet.corners_away : store.$i18n.t('order.cornersNC')) + ')';
            } else {
                score = ' (' + (bet.score ? bet.score : store.$i18n.t('order.NC')) + ')';
            }
            market = store.$i18n.t('panel.marketLive') + ' | ';
        } else {
            market = store.$i18n.t('panel.marketDball') + ' | ';
        }

        if (bet.type === Constants.BET_TYPE_1X2_HOME) {
            betInfo = bet.team_home_name + ' ' + odds + score;
            betType = '1X2';
        } else if (bet.type === Constants.BET_TYPE_1X2_AWAY) {
            betInfo = bet.team_away_name + ' ' + odds + score;
            betType = '1X2';
        } else if (bet.type === Constants.BET_TYPE_1X2_DRAW) {
            betInfo = store.$i18n.t('bet.popup.draw') + odds + score;
            betType = '1X2';
        } else if (bet.type === Constants.BET_TYPE_HANDICAP_JOLLY || bet.type === Constants.BET_TYPE_HANDICAP_DOG) {
            let team = bet.teamwhere === Constants.TEAM_HOME ? bet.team_home_name : bet.team_away_name;
            betInfo = team + ' ' + (handicap > 0 ? '+' : '') + handicap + odds + score;
            betType = store.$i18n.t('panel.asianHandicap') + ' ';
        } else if (bet.type === Constants.BET_TYPE_CORNERS_HANDICAP_JOLLY || bet.type === Constants.BET_TYPE_CORNERS_HANDICAP_DOG) {
            let team = bet.teamwhere === Constants.TEAM_HOME ? bet.team_home_name : bet.team_away_name;
            betInfo = team + ' ' + (handicap > 0 ? '+' : '') + handicap + odds + score;
            betType = store.$i18n.t('panel.cornersAsianHandicap') + ' ';
        } else if (bet.type === Constants.BET_TYPE_GOAL_OVER) {
            betInfo = store.$i18n.t('betDialog.over') + ' ' + handicap + odds + score;
            betType = store.$i18n.t('panel.goal');
        } else if (bet.type === Constants.BET_TYPE_GOAL_UNDER) {
            betInfo = store.$i18n.t('betDialog.under') + ' ' + handicap + odds + score;
            betType = store.$i18n.t('panel.goal');
        } else if (bet.type === Constants.BET_TYPE_CORNERS_GOAL_OVER) {
            betInfo = store.$i18n.t('betDialog.over') + ' ' + handicap + odds + score;
            betType = store.$i18n.t('panel.cornersGoal');
        } else if (bet.type === Constants.BET_TYPE_CORNERS_GOAL_UNDER) {
            betInfo = store.$i18n.t('betDialog.under') + ' ' + handicap + odds + score;
            betType = store.$i18n.t('panel.cornersGoal');
        } else if (bet.type === Constants.BET_TYPE_BTTS_YES) {
            betInfo = store.$i18n.t('betDialog.yes') + ' ' + odds + score;
            betType = store.$i18n.t('betDialog.btts');
        } else if (bet.type === Constants.BET_TYPE_BTTS_NO) {
            betInfo = store.$i18n.t('betDialog.no') + ' ' + odds + score;
            betType = store.$i18n.t('betDialog.btts');
        } else if (bet.type === Constants.BET_TYPE_DC_HOME_OR_DRAW) {
            betInfo = store.$i18n.t('betDialog.home') + store.$i18n.t('betDialog.or') + store.$i18n.t('betDialog.draw') + ' ' + odds + score;
            betType = store.$i18n.t('betDialog.doubleChance');
        } else if (bet.type === Constants.BET_TYPE_DC_HOME_OR_AWAY) {
            betInfo = store.$i18n.t('betDialog.home') + store.$i18n.t('betDialog.or') + store.$i18n.t('betDialog.away') + ' ' + odds + score;
            betType = store.$i18n.t('betDialog.doubleChance');
        } else if (bet.type === Constants.BET_TYPE_DC_DRAW_OR_AWAY) {
            betInfo = store.$i18n.t('betDialog.draw') + store.$i18n.t('betDialog.or') + store.$i18n.t('betDialog.away') + ' ' + odds + score;
            betType = store.$i18n.t('betDialog.doubleChance');
        } else if (bet.type === Constants.BET_TYPE_CS_CS) {
            betInfo = bet.correct_score + ' ' + odds + score;
            betType = store.$i18n.t('betDialog.correctScore');
        }

        gameInfo =
            bet.league_name +
            '<br />' +
            (!bet.is_live && bet.event_started_at ? Vue.filter('formatInTimeZone')(bet.event_started_at, 'dd MMM H:mm', true) + '<br />' : '') +
            game +
            '<br />' +
            market +
            period +
            betType +
            '<br />' +
            betInfo +
            minute +
            // betting +
            bookmaker +
            ' ' +
            stake;

        return gameInfo;
    },
    getOrderName(item, twoLines = false, withTeam = true) {
        let user = store.getters['UserModule/getUser'];
        let order = '';
        let game = withTeam ? ' [' + store.$i18n.t('bet.game') + ']' : '';
        let period = item.period_type_id === Constants.GAME_PERIOD_FT ? store.$i18n.t('order.periodFTAbbr') : store.$i18n.t('order.period1HAbbr');
        let stake = ' <div class="float-end">' + utils.getCurrencySymbol(user.currency) + parseFloat(item.stake).toFixed(2) + '</div>';

        let handicap = parseFloat(item.handicap).toFixed(2);

        if (handicap === '0.00') {
            handicap = 0;
        }

        switch (item.bet_selection_id) {
            case Constants.BET_SELECTION_TEAM_HOME:
                order +=
                    '<div class="text-truncate panel-order-big pr-1">' +
                    item.team_home_name +
                    '</div>' +
                    ' • ' +
                    period +
                    '|A/H' +
                    (twoLines ? '<br>' : ' ') +
                    (item.jollywhere === Constants.TEAM_HOME ? '' : handicap > 0 ? '+' : '') +
                    handicap;

                break;
            case Constants.BET_SELECTION_CORNERS_TEAM_HOME:
                order +=
                    '<div class="text-truncate panel-order-big pr-1">' +
                    item.team_home_name +
                    '</div>' +
                    ' • ' +
                    period +
                    '|' +
                    store.$i18n.t('order.cornersHandicapAbbr') +
                    (twoLines ? '<br>' : ' ') +
                    (item.jollywhere === Constants.TEAM_HOME ? '' : handicap > 0 ? '+' : '') +
                    handicap;

                break;
            case Constants.BET_SELECTION_TEAM_AWAY:
                order +=
                    '<div class="text-truncate panel-order-big pr-1">' +
                    item.team_away_name +
                    '</div>' +
                    ' • ' +
                    period +
                    '|A/H' +
                    (twoLines ? '<br>' : ' ') +
                    (item.jollywhere === Constants.TEAM_AWAY ? '' : handicap > 0 ? '+' : '') +
                    handicap;
                break;
            case Constants.BET_SELECTION_CORNERS_TEAM_AWAY:
                order +=
                    '<div class="text-truncate panel-order-big pr-1">' +
                    item.team_away_name +
                    '</div>' +
                    ' • ' +
                    period +
                    '|' +
                    store.$i18n.t('order.cornersHandicapAbbr') +
                    (twoLines ? '<br>' : ' ') +
                    (item.jollywhere === Constants.TEAM_AWAY ? '' : handicap > 0 ? '+' : '') +
                    handicap;
                break;
            case Constants.BET_SELECTION_TEAM_OVER:
            case Constants.BET_SELECTION_TEAM_UNDER:
                order +=
                    (withTeam ? '<div class="text-truncate panel-order pr-1">' + item.team_home_name + '</div>' : '') +
                    game +
                    (withTeam ? ' • ' + period : period) +
                    '|O/U' +
                    (twoLines ? '<br>' : '') +
                    (item.bet_selection_id == Constants.BET_SELECTION_TEAM_OVER ? store.$i18n.t('betDialog.over') : store.$i18n.t('betDialog.under')) +
                    ' ' +
                    handicap;
                break;
            case Constants.BET_SELECTION_CORNERS_TEAM_OVER:
            case Constants.BET_SELECTION_CORNERS_TEAM_UNDER:
                order +=
                    (withTeam ? '<div class="text-truncate panel-order pr-1">' + item.team_home_name + '</div>' : '') +
                    game +
                    (withTeam ? ' • ' + period : period) +
                    '|' +
                    store.$i18n.t('order.cornersGoalAbbr') +
                    (twoLines ? '<br>' : '') +
                    (item.bet_selection_id == Constants.BET_SELECTION_CORNERS_TEAM_OVER ? store.$i18n.t('betDialog.over') : store.$i18n.t('betDialog.under')) +
                    ' ' +
                    handicap;
                break;
            case Constants.BET_SELECTION_YES:
            case Constants.BET_SELECTION_NO:
                order +=
                    (withTeam ? '<div class="text-truncate panel-order pr-1">' + item.team_home_name + '</div>' : '') +
                    game +
                    (withTeam ? ' • ' + period : period) +
                    '|' +
                    store.$i18n.t('betDialog.bts') +
                    (twoLines ? '<br>' : '') +
                    (item.bet_selection_id == Constants.BET_SELECTION_YES ? store.$i18n.t('betDialog.yes') : store.$i18n.t('betDialog.no'));
                break;
            case Constants.BET_SELECTION_TEAM_ONE:
                order +=
                    '<div class="text-truncate panel-order-big pr-1">' + item.team_home_name + '</div>' + ' • ' + period + '|1X2' + (twoLines ? '<br>' : '');
                break;
            case Constants.BET_SELECTION_TEAM_X:
                order +=
                    (withTeam ? '<div class="text-truncate panel-order-big pr-1">' + item.team_home_name + '</div>' : '') +
                    (withTeam ? ' • ' + period : period) +
                    '|1X2' +
                    (twoLines ? '<br>' : '') +
                    ' ' +
                    store.$i18n.t('order.draw');
                break;
            case Constants.BET_SELECTION_TEAM_TWO:
                order +=
                    '<div class="text-truncate panel-order-big pr-1">' + item.team_away_name + '</div>' + ' • ' + period + '|1X2' + (twoLines ? '<br>' : '');
                break;
            case Constants.BET_SELECTION_TEAM_1X:
                order +=
                    (withTeam ? '<div class="text-truncate panel-order-big pr-1">' + item.team_home_name + '</div>' : '') +
                    (withTeam ? ' • ' + period : period) +
                    '|' +
                    store.$i18n.t('order.dc') +
                    (twoLines ? '<br>' : '') +
                    ' ' +
                    store.$i18n.t('betDialog.home') +
                    store.$i18n.t('betDialog.or') +
                    store.$i18n.t('betDialog.draw');
                break;
            case Constants.BET_SELECTION_TEAM_12:
                order +=
                    (withTeam ? '<div class="text-truncate panel-order-big pr-1">' + item.team_home_name + '</div>' : '') +
                    (withTeam ? ' • ' + period : period) +
                    '|' +
                    store.$i18n.t('order.dc') +
                    (twoLines ? '<br>' : '') +
                    ' ' +
                    store.$i18n.t('betDialog.home') +
                    store.$i18n.t('betDialog.or') +
                    store.$i18n.t('betDialog.away');
                break;
            case Constants.BET_SELECTION_TEAM_X2:
                order +=
                    (withTeam ? '<div class="text-truncate panel-order-big pr-1">' + item.team_home_name + '</div>' : '') +
                    (withTeam ? ' • ' + period : period) +
                    '|' +
                    store.$i18n.t('order.dc') +
                    (twoLines ? '<br>' : '') +
                    ' ' +
                    store.$i18n.t('betDialog.draw') +
                    store.$i18n.t('betDialog.or') +
                    store.$i18n.t('betDialog.away');
                break;
            case Constants.BET_SELECTION_CS:
                order +=
                    '<div class="text-truncate panel-order-big pr-1">' +
                    item.team_home_name +
                    '</div>' +
                    ' • ' +
                    period +
                    '|' +
                    store.$i18n.t('order.cs') +
                    (twoLines ? '<br>' : '') +
                    ' ' +
                    item.correct_score;
                break;
            default:
                break;
        }

        order += ' ';

        order += '@' + utils.formatOdds(item.odds);
        let score = '';

        if (
            item.bet_selection_id === Constants.BET_SELECTION_CORNERS_TEAM_HOME ||
            item.bet_selection_id === Constants.BET_SELECTION_CORNERS_TEAM_AWAY ||
            item.bet_selection_id === Constants.BET_SELECTION_CORNERS_TEAM_OVER ||
            item.bet_selection_id === Constants.BET_SELECTION_CORNERS_TEAM_UNDER
        ) {
            score += '(' + (item.corners ? item.corners : store.$i18n.t('bet.NC')) + ')';
        } else {
            score = ' (' + (item.score ? item.score : store.$i18n.t('bet.NC')) + ')';
        }
        order += item.is_live ? score : '';
        order += stake;

        return order;
    },
    orderInfoForTooltip(item) {
        let orderInfo = '';
        let betInfo = '';
        let score = '';
        let market = '';
        let minute = '';
        // let bookmaker = Constants.SITE_NAME[item.site_id];

        if (item.time) {
            let timeArr = item.time.split(' ');

            if (timeArr[0] === '1H') {
                minute = ' ' + timeArr[1];
            } else if (timeArr[0] === '2H') {
                minute = ' ' + (45 + parseInt(timeArr[1].replace("'", ''))) + "'";
            }
        }

        let betType = '';
        let game = item.team_home_name + ' vs ' + item.team_away_name;

        let period = (item.period_type_id === Constants.GAME_PERIOD_FT ? store.$i18n.t('panel.marketFT') : store.$i18n.t('panel.market1H')) + ' | ';
        let handicap = parseFloat(item.handicap).toFixed(2);
        let user = store.getters['UserModule/getUser'];

        if (handicap === '0.00') {
            handicap = 0;
        }

        let odds = ' @' + utils.formatOdds(item.odds);
        let stake = utils.getCurrencySymbol(user.currency) + parseFloat(item.stake).toFixed(2);

        if (item.is_live) {
            if (
                item.bet_selection_id === Constants.BET_SELECTION_CORNERS_TEAM_HOME ||
                item.bet_selection_id === Constants.BET_SELECTION_CORNERS_TEAM_AWAY ||
                item.bet_selection_id === Constants.BET_SELECTION_CORNERS_TEAM_OVER ||
                item.bet_selection_id === Constants.BET_SELECTION_CORNERS_TEAM_UNDER
            ) {
                score += '(' + (item.corners !== null ? item.corners : store.$i18n.t('order.orderNC')) + ')';
            } else {
                score = ' (' + (item.score ? item.score : store.$i18n.t('order.NC')) + ')';
            }

            market = store.$i18n.t('panel.marketLive') + ' | ';
        } else {
            market = store.$i18n.t('panel.marketDball') + ' | ';
        }

        switch (item.bet_selection_id) {
            case Constants.BET_SELECTION_TEAM_HOME:
                betInfo = item.team_home_name + ' ' + (item.jollywhere === Constants.TEAM_HOME ? '' : handicap > 0 ? '+' : '') + handicap + odds + score;
                betType = store.$i18n.t('panel.asianHandicap');
                break;
            case Constants.BET_SELECTION_TEAM_AWAY:
                betInfo = item.team_away_name + ' ' + (item.jollywhere === Constants.TEAM_AWAY ? '' : handicap > 0 ? '+' : '') + handicap + odds + score;
                betType = store.$i18n.t('panel.asianHandicap');
                break;
            case Constants.BET_SELECTION_CORNERS_TEAM_HOME:
                betInfo = item.team_home_name + ' ' + (item.jollywhere === Constants.TEAM_HOME ? '' : handicap > 0 ? '+' : '') + handicap + odds + score;
                betType = store.$i18n.t('panel.cornersAsianHandicap');
                break;
            case Constants.BET_SELECTION_CORNERS_TEAM_AWAY:
                betInfo = item.team_away_name + ' ' + (item.jollywhere === Constants.TEAM_AWAY ? '' : handicap > 0 ? '+' : '') + handicap + odds + score;
                betType = store.$i18n.t('panel.cornersAsianHandicap');
                break;
            case Constants.BET_SELECTION_TEAM_OVER:
                betInfo = store.$i18n.t('betDialog.over') + ' ' + handicap + odds + score;
                betType = store.$i18n.t('panel.goal');
                break;
            case Constants.BET_SELECTION_TEAM_UNDER:
                betInfo = store.$i18n.t('betDialog.under') + ' ' + handicap + odds + score;
                betType = store.$i18n.t('panel.goal');
                break;
            case Constants.BET_SELECTION_CORNERS_TEAM_OVER:
                betInfo = store.$i18n.t('betDialog.over') + ' ' + handicap + odds + score;
                betType = store.$i18n.t('panel.cornersGoal');
                break;
            case Constants.BET_SELECTION_CORNERS_TEAM_UNDER:
                betInfo = store.$i18n.t('betDialog.under') + ' ' + handicap + odds + score;
                betType = store.$i18n.t('panel.cornersGoal');
                break;
            case Constants.BET_SELECTION_TEAM_ONE:
                betInfo = item.team_home_name + ' ' + odds + score;
                betType = '1X2';
                break;
            case Constants.BET_SELECTION_TEAM_TWO:
                betInfo = item.team_away_name + ' ' + odds + score;
                betType = '1X2';
                break;
            case Constants.BET_SELECTION_TEAM_X:
                betInfo = store.$i18n.t('bet.popup.draw') + odds + score;
                betType = '1X2';
                break;
            case Constants.BET_SELECTION_YES:
                betInfo = store.$i18n.t('betDialog.yes') + ' ' + odds + score;
                betType = store.$i18n.t('betDialog.btts');
                break;
            case Constants.BET_SELECTION_NO:
                betInfo = store.$i18n.t('betDialog.no') + ' ' + odds + score;
                betType = store.$i18n.t('betDialog.btts');
                break;
            case Constants.BET_SELECTION_TEAM_1X:
                betInfo = store.$i18n.t('betDialog.home') + store.$i18n.t('betDialog.or') + store.$i18n.t('betDialog.draw') + ' ' + odds + score;
                betType = store.$i18n.t('betDialog.doubleChance');
                break;
            case Constants.BET_SELECTION_TEAM_12:
                betInfo = store.$i18n.t('betDialog.home') + store.$i18n.t('betDialog.or') + store.$i18n.t('betDialog.away') + ' ' + odds + score;
                betType = store.$i18n.t('betDialog.doubleChance');
                break;
            case Constants.BET_SELECTION_TEAM_X2:
                betInfo = store.$i18n.t('betDialog.draw') + store.$i18n.t('betDialog.or') + store.$i18n.t('betDialog.away') + ' ' + odds + score;
                betType = store.$i18n.t('betDialog.doubleChance');
                break;
            case Constants.BET_SELECTION_CS:
                betInfo = item.correct_score + ' ' + odds + score;
                betType = store.$i18n.t('betDialog.correctScore');
                break;
            default:
                break;
        }

        orderInfo = item.league_name + '<br />' + game + '<br />' + market + period + betType + '<br />' + betInfo + minute + ' ' + stake;

        return orderInfo;
    },
    showMessage(
        messages,
        showCloseButton = false,
        color = 'lightGreenMsg',
        timeout = 3000,
        top = false,
        bottom = true,
        left = false,
        right = false,
        icon = null
    ) {
        if (_.isString(messages)) {
            messages = {
                message: messages,
                showCloseButton: showCloseButton,
                color: color,
                timeout: timeout,
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                icon: icon,
                contentClass: '',
            };
        }

        store.commit('AppModule/setMessages', messages);
    },
    newBetMessage(message) {
        this.showMessage(message, true, 'green', 5000, true, false, false, true, 'mdi-receipt-text-check-outline');
    },
    orderClosedMessage(message, color) {
        this.showMessage(message, true, color, 5000, true, false, false, true, 'mdi-clipboard-clock-outline');
    },
    failMessage(message) {
        this.showMessage(message, false, 'lightRedMsg', 3000, false, true, false, false, 'mdi-alert-circle-outline', 'text-center py-0');
    },
    successMessage(message) {
        this.showMessage(message, false, 'lightGreenMsg', 3000, false, true, false, false, 'mdi-checkbox-marked-circle', 'py-0');
    },
    playSound(url) {
        const audio = new Audio(url);
        audio.play();
    },
    wlCalculate(type, teamwhere, ftscore, irscore, correctScore, handicap, odds, stake, wl) {
        teamwhere = parseInt(teamwhere);
        handicap = parseFloat(handicap);
        odds = parseFloat(odds);
        stake = parseFloat(stake);
        teamwhere = parseInt(teamwhere);

        let result = [];

        let scoreArr = ftscore.split('-');
        let home = parseInt(scoreArr[0]);
        let away = parseInt(scoreArr[1]);

        let irscoreArr = irscore.split('-');
        let irhome = parseInt(irscoreArr[0]);
        let iraway = parseInt(irscoreArr[1]);

        if (!wl) {
            if (
                type === Constants.BET_TYPE_HANDICAP_JOLLY ||
                type === Constants.BET_TYPE_HANDICAP_DOG ||
                type === Constants.BET_TYPE_CORNERS_HANDICAP_JOLLY ||
                type === Constants.BET_TYPE_CORNERS_HANDICAP_DOG ||
                type === Constants.BET_TYPE_GOAL_OVER ||
                type === Constants.BET_TYPE_GOAL_UNDER ||
                type === Constants.BET_TYPE_CORNERS_GOAL_OVER ||
                type === Constants.BET_TYPE_CORNERS_GOAL_UNDER
            ) {
                let diff = null;

                if (
                    type === Constants.BET_TYPE_HANDICAP_JOLLY ||
                    type === Constants.BET_TYPE_HANDICAP_DOG ||
                    type === Constants.BET_TYPE_CORNERS_HANDICAP_JOLLY ||
                    type === Constants.BET_TYPE_CORNERS_HANDICAP_DOG
                ) {
                    if (home < irhome || away < iraway) {
                        result['a'] = null;
                        result['balance'] = null;
                        result['valid_stake'] = null;

                        return result;
                    }

                    ftscore = home - irhome + '-' + (away - iraway);

                    scoreArr = ftscore.split('-');
                    home = parseInt(scoreArr[0]);
                    away = parseInt(scoreArr[1]);

                    if (teamwhere === Constants.TEAMWHERE_HOME) {
                        home += handicap;
                        diff = home - away;
                    } else {
                        away += handicap;
                        diff = away - home;
                    }
                } else if (
                    type === Constants.BET_TYPE_GOAL_OVER ||
                    type === Constants.BET_TYPE_GOAL_UNDER ||
                    type === Constants.BET_TYPE_CORNERS_GOAL_OVER ||
                    type === Constants.BET_TYPE_CORNERS_GOAL_UNDER
                ) {
                    let goals = home + away;
                    if (teamwhere === Constants.TEAMWHERE_HOME) {
                        diff = goals - handicap;
                    } else {
                        diff = handicap - goals;
                    }
                }

                if (diff >= 0.5) {
                    // win
                    wl = 'W';
                } else if (diff == 0.25) {
                    // half win
                    wl = 'HW';
                } else if (diff == 0) {
                    // push
                    wl = 'P';
                } else if (diff == -0.25) {
                    // half loss
                    wl = 'HL';
                } else if (diff <= -0.5) {
                    // loss
                    wl = 'L';
                } else {
                    wl = null;
                }
            } else if (type === Constants.BET_TYPE_1X2_HOME) {
                if (home > away) {
                    wl = 'W';
                } else {
                    wl = 'L';
                }
            } else if (type === Constants.BET_TYPE_1X2_AWAY) {
                if (home < away) {
                    wl = 'W';
                } else {
                    wl = 'L';
                }
            } else if (type === Constants.BET_TYPE_1X2_DRAW) {
                if (home === away) {
                    wl = 'W';
                } else {
                    wl = 'L';
                }
            } else if (type === Constants.BET_TYPE_BTTS_YES) {
                wl = home > 0 && away > 0 ? 'W' : 'L';
            } else if (type === Constants.BET_TYPE_BTTS_NO) {
                wl = home > 0 && away > 0 ? 'L' : 'W';
            } else if (type === Constants.BET_TYPE_DC_HOME_OR_DRAW) {
                wl = home >= away ? 'W' : 'L';
            } else if (type === Constants.BET_TYPE_DC_HOME_OR_AWAY) {
                wl = home > away || away > home ? 'W' : 'L';
            } else if (type === Constants.BET_TYPE_DC_DRAW_OR_AWAY) {
                wl = away >= home ? 'W' : 'L';
            } else if (type === Constants.BET_TYPE_CS_CS) {
                let correctScoreArr = correctScore.split('-');
                let homeCorrect = parseInt(correctScoreArr[0]);
                let awayCorrect = parseInt(correctScoreArr[1]);
                wl = home === homeCorrect && away === awayCorrect ? 'W' : 'L';
            }
        }
        let valid_stake = null;
        let balance = null;

        if (wl) {
            switch (wl) {
                case 'P':
                    balance = valid_stake = 0;
                    break;
                case 'W':
                    balance = stake * odds - stake;
                    valid_stake = Math.abs(balance);
                    break;
                case 'HW':
                    balance = (stake * odds - stake) / 2;
                    valid_stake = Math.abs(balance);
                    break;
                case 'L':
                    balance = 0 - stake;
                    valid_stake = Math.abs(balance);
                    break;
                case 'HL':
                    balance = 0 - stake / 2;
                    valid_stake = Math.abs(balance);
                    break;
            }
        }

        result['wl'] = wl;

        if (balance !== null) {
            result['balance'] = balance;
            result['valid_stake'] = valid_stake;
        }

        return result;
    },
    getBetMinute(item) {
        if (item.time === 'HT' || item.time.toUpperCase() === 'LIVE') {
            return item.time;
        } else if (item.time_h === Constants.TIME_PERIOD_FT) {
            let minute = 45 + item.time_min;
            return (minute <= 90 ? minute : '90+' + (minute - 90)) + "'";
        }

        return (item.time_min <= 45 ? item.time_min : '45+' + (item.time_min - 45)) + "'";
    },
    getWebSocketURL(token) {
        return (
            (location.protocol === 'http:' ? 'ws' : 'wss') +
            '://' +
            location.hostname +
            ':' +
            location.port +
            '/ws?token=' +
            token +
            '&appId=' +
            store.getters['getUniqAppId'] /* +
            (store.state.AppModule.isInitialized === false ? '&init=true' : '')*/
        );
    },

    reload() {
        if (this.getPlatform() === Constants.PLATFORM_TRADEBALL) {
            window.location.reload();
        } else {
            let protocol = window.location.protocol + '//';
            let domain = window.location.hostname.replace('tradeball.', '');
            let url = protocol + domain + '/tradeball' + window.location.pathname;
            console.log('Location replace url: ' + url);
            window.parent.location.replace(url);
        }
    },

    getPlatform() {
        let platform;
        switch (true) {
            case location.hostname === 'www.tradeball.com':
            case location.hostname === '5.79.64.136':
            case location.hostname === '178.162.165.24':
            case location.hostname === '37.48.124.53':
            case location.hostname === 'tradeball2': //localhost
            case location.hostname === 'tradeballv2': //localhost
            case location.hostname === '192.168.1.241': //localhost
            case location.hostname === 'devtoolv3.tradeball.com': //vue3
                platform = Constants.PLATFORM_TRADEBALL;
                break;
            case location.hostname.includes('.local'): //localhost
            case location.hostname === 'wl.tradeball.com':
            case location.hostname === 'tradeball.bet-bra-staging.com':
            case location.hostname === 'tradeball.bet-bra.com':
                platform = Constants.PLATFORM_WL_BETBRA;
                break;
            case location.hostname === 'tradeball.apostasnow-staging.com':
            case location.hostname === 'tradeball.apostasnow.com':
                platform = Constants.PLATFORM_WL_APOSTASNOW;
                break;
            case location.hostname === 'tradeball.apostasbf-staging.com':
            case location.hostname === 'tradeball.apostasbf.com':
                platform = Constants.PLATFORM_WL_APOSTASBF;
                break;
            case location.hostname === 'tradeball.drinbetzero-staging.com':
            case location.hostname === 'tradeball.drinbetzero.com':
                platform = Constants.PLATFORM_WL_DRINBETZERO;
                break;
            case location.hostname === 'tradeball.bolsadeaposta-staging.com':
            case location.hostname === 'tradeball.bolsadeaposta.com':
                platform = Constants.PLATFORM_WL_BOLSADEAPOSTA;
                break;
            case location.hostname === 'tradeball.greenwin-staging.com':
            case location.hostname === 'tradeball.greenwin.bet':
                platform = Constants.PLATFORM_WL_GREENWIN;
                break;
            case location.hostname === 'tradeball.betbox-staging.com':
            case location.hostname === 'tradeball.betbox.bet':
                platform = Constants.PLATFORM_WL_BETBOX;
                break;
            case location.hostname === 'tradeball.fulltbet-staging.com':
            case location.hostname === 'tradeball.fulltbet.com':
                platform = Constants.PLATFORM_WL_FULLTBET;
                break;
            case location.hostname === 'tradeball.verdinhabet-staging.com':
            case location.hostname === 'tradeball.verdinhabet.com':
                platform = Constants.PLATFORM_WL_VERDINHABET;
                break;
            case location.hostname === 'tradeball.oddjusta-staging.com':
            case location.hostname === 'tradeball.oddjusta.com':
                platform = Constants.PLATFORM_WL_ODDJUSTA;
                break;
            default:
                console.log('Unknown platform: ' + location.hostname);
                break;
        }

        return platform;
    },
    userTimezoneOffset() {
        return Vue.filter('formatInTimeZone')(new Date(), 'XXX', true);
    },
    arrayChangePosition(arr, oldIndex, newIndex) {
        if (newIndex >= arr.length) {
            var k = newIndex - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
        return arr;
    },
    isSkipJsValidation() {
        return JSON.parse(localStorage.getItem('app'))?.skipJsValidation ?? false;
    },
    listSiteQtip: function (datas, withValues = true, siteIdIdx = 0, priceIdx = 1) {
        let qtip = '';
        let precision = 3;

        if (datas) {
            datas.forEach(function (data) {
                if (data[siteIdIdx] == Constants.SITE_IBC_ID) {
                    data[priceIdx] = Math.floor(data[priceIdx] * 100) / 100;
                }
                qtip += '<span style="width: 75px;display: inline-block;">' + Constants.SITE_NAME[data[siteIdIdx]] + '</span>';
                qtip += withValues ? ' ' + utils.formatOdds(data[priceIdx], precision) + '<br>' : '<br>';
            });
        }

        return qtip;
    },
    defaultOrderBySite: function (datas) {
        let arr = [...datas]; //copy
        const bookmakersOrderMap = {
            10: 1, //Pinna
            17: 2, //BF
            22: 3, //Matchbook
            11: 4, //ISN
            21: 5, //3et
            19: 6, //Sharpbet
            3: 7, //IBC
            1: 8, //SBO
            5: 9, //SING
            20: 10, //PINNWEB
            16: 11, //ISC
            18: 12, //SPORTMONKS/DataProvider
        };

        // Sort array datas based on the indices in array a
        return arr.sort((x, y) => bookmakersOrderMap[x[0]] - bookmakersOrderMap[y[0]]);
    },

    listSiteDataQtip: function (datas, clId, clLCId) {
        let qtipArray = [];
        let ibcProviderIndex, sboProviderIndex;
        let idx = 0;

        for (let key in datas) {
            const siteId = datas[key][0];
            if (siteId === Constants.SITE_BETFAIR_ID || siteId === Constants.SITE_PINNWEB_ID) {
                continue;
            }

            let bookmakerName;
            if(siteId === Constants.SITE_SBO_ID && !Constants.SBOBET_ALLOWED_CUSTOM_LEAGUES_IDS.includes(clId)) {
                bookmakerName = 'Data Provider 3';
                sboProviderIndex = idx;
            } else if(siteId === Constants.SITE_IBC_ID && !Constants.IBCBET_ALLOWED_LIMITS_CATEGORY_IDS.includes(clLCId)) {
                bookmakerName = 'Data Provider 2';
                ibcProviderIndex = idx;
            } else {
                bookmakerName = Constants.SITE_NAME[siteId];
            }
            const width = 100;

            qtipArray.push(`<span style="width: ${width}px; display: inline-block;">${bookmakerName}</span> ${datas[key][1]}<br>`);
            idx++;
        }

        if(ibcProviderIndex !== undefined) {
            //no need to change indexes in array
            const moved = qtipArray[ibcProviderIndex];
            qtipArray[ibcProviderIndex] = null;
            qtipArray.push(moved);
        }

        if(sboProviderIndex !== undefined) {
            //no need to change indexes in array
            const moved = qtipArray[sboProviderIndex];
            qtipArray[sboProviderIndex] = null;
            qtipArray.push(moved);
        }

        return qtipArray.join('');
    },
    getBetDialogRef(id) {
        return 'betDialog' + id;
    },
    roundPrice(price, precision = 3) {
        const x = 10 ** precision;
        return (Math.trunc(price * x) / x).toFixed(precision);
    },

    extractPriceData(price, handicapKey, oddsMaxKey, betTypeId, oddsListKey) {
        let market = {};

        let oddsMaxSiteKey = oddsMaxKey + 'S';
        if (oddsMaxKey.includes('_')) {
            //over,under,home,away,yes,no from event
            oddsMaxSiteKey = oddsMaxKey + '_site_id';
        }

        if (betTypeId === Constants.BET_TYPE_HANDICAP || betTypeId === Constants.BET_TYPE_CORNERS_HANDICAP) {
            market['jw'] = price['jw'] ?? price['jollywhere'];
        }
        market['handicap'] = price[handicapKey] ?? null;
        market['price_list'] = price[oddsListKey];
        market['price_max'] = price[oddsMaxKey];
        market['price_max_site_id'] = price[oddsMaxSiteKey];

        return market;
    },

    async updateUserData(withFeedReload = false) {
        let moduleName = router.currentRoute.meta.moduleName;

        let payload = {
            markets: {},
            eventPopupData: null,
        };

        let event = store.getters['EventModule/getEvent'];

        if (!_.isEmpty(event)) {
            payload.eventPopupData = {
                customEventId: event.ceId,
                tradingTypeId: Constants.TRADING_TYPE_ORDER,
                eventDate: event.dg,
            };
        }

        let filters = moduleName ? this.filtersParams(moduleName) : {};

        if (moduleName === 'BoardModule') {
            let versionLive = withFeedReload ? -1 : store.getters['FeedLiveModule/getVersion'];
            let versionToday = withFeedReload ? -1 : store.getters['FeedDballModule/getTodayVersion'];
            let versionEarly = withFeedReload ? -1 : store.getters['FeedDballModule/getEarlyVersion'];

            payload.markets[Constants.DBALL_MARKET_LIVE] = {
                feedVersion: versionLive,
                filter: filters,
            };
            payload.markets[Constants.DBALL_MARKET_TODAY] = {
                feedVersion: versionToday,
                filter: filters,
            };
            payload.markets[Constants.DBALL_MARKET_EARLY] = {
                feedVersion: versionEarly,
                filter: filters,
            };
        } else if (filters.marketId) {
            let version = -1;

            switch (filters.marketId) {
                case Constants.DBALL_MARKET_LIVE:
                    version = withFeedReload ? -1 : store.getters[moduleName + '/getVersion'];
                    break;
                case Constants.DBALL_MARKET_TODAY:
                    version = withFeedReload ? -1 : store.getters['FeedDballModule/getTodayVersion'];
                    break;
                case Constants.DBALL_MARKET_EARLY:
                    version = withFeedReload ? -1 : store.getters['FeedDballModule/getEarlyVersion'];
                    break;
            }

            payload.markets[filters.marketId] = {
                feedVersion: version,
                filter: filters,
            };
        }

        let pageCode = moduleName.replace('Module', '');

        payload.pageCode = pageCode.charAt(0).toLowerCase() + pageCode.slice(1);
        payload.pageUrl = window.location.toString();

        payload = await this.bettingPopupDataToPayload(payload, moduleName);

        await this.updateUserDataEvent(payload);
    },

    customEventIds(moduleName) {
        let moduleFilters = store.getters[moduleName + '/getFilters'];

        if (moduleFilters.betCustomEventIds === undefined) {
            return [];
        }
        //skip reactivity
        let customEventIds = JSON.parse(JSON.stringify(moduleFilters.betCustomEventIds));
        if (moduleFilters.customEventId) {
            customEventIds.push(moduleFilters.customEventId);
        }

        return customEventIds;
    },

    filtersParams(moduleName) {
        let moduleFilters = store.getters[moduleName + '/getFilters'];

        let filters = {
            line: moduleFilters.line,
            periodTypeId:
                (moduleFilters.marketId === Constants.DBALL_MARKET_TODAY || moduleFilters.marketId === Constants.DBALL_MARKET_EARLY) &&
                router.currentRoute.meta.tradingTypeId === Constants.TRADING_TYPE_BOT
                    ? Constants.GAME_PERIOD_FT
                    : moduleFilters.periodTypeId,
            customEventIds: this.customEventIds(moduleName).join(','),
        };

        if (moduleFilters.marketId === Constants.DBALL_MARKET_EARLY) {
            if (moduleFilters.search) {
                filters.search = moduleFilters.search;
                filters.date = null;
            } else {
                filters.date = moduleFilters.dateTo;
                filters.search = null;
            }
        }

        if (moduleFilters.marketId) {
            filters.marketId = moduleFilters.marketId;
        }

        if (router.currentRoute.meta && router.currentRoute.meta.tradingTypeId) {
            filters.tradingTypeId = router.currentRoute.meta.tradingTypeId;
        }

        // if (moduleName === 'BoardModule') {
        //     filters.favoriteCustomEventIds = this.$store.getters['AppModule/getFavoriteEvent'].join(',');
        // }

        return filters;
    },

    async bettingPopupDataToPayload(payload, moduleName) {
        payload['bettingPopupData'] = {};
        let toolUserSettings = store.getters['AppModule/getToolUserSettings'];
        let siteIds = toolUserSettings.bet_order_site_ids_allowed;

        let betFeedDataFeed = store.getters[moduleName + '/getBetFeedData']; // Live/Dball/Board

        let event = store.getters['EventModule/getEvent'];
        let betFeedDataTotal = {};

        if (!_.isEmpty(event)) {
            let betFeedDataEvent = store.getters['EventModule/getBetFeedData'];
            //skip reactivity
            betFeedDataTotal = JSON.parse(JSON.stringify(betFeedDataEvent));

            if (betFeedDataFeed) {
                let maxKey = Object.keys(betFeedDataEvent).length;

                Object.keys(betFeedDataFeed).forEach((key) => {
                    betFeedDataTotal[maxKey] = betFeedDataFeed[key];
                    maxKey = maxKey + 1;
                });
            }
        } else if (betFeedDataFeed) {
            betFeedDataTotal = JSON.parse(JSON.stringify(betFeedDataFeed));
        }

        Object.keys(betFeedDataTotal).forEach((key) => {
            let handicap = null;
            if (betFeedDataTotal[key].market.handicap) {
                handicap = betFeedDataTotal[key].market.handicap;

                if (
                    (betFeedDataTotal[key].betSelectionId === Constants.BET_SELECTION_TEAM_HOME && betFeedDataTotal[key].market.jw === Constants.TEAM_HOME) ||
                    (betFeedDataTotal[key].betSelectionId === Constants.BET_SELECTION_TEAM_AWAY && betFeedDataTotal[key].market.jw === Constants.TEAM_AWAY) ||
                    (betFeedDataTotal[key].betSelectionId === Constants.BET_SELECTION_CORNERS_TEAM_HOME &&
                        betFeedDataTotal[key].market.jw === Constants.TEAM_HOME) ||
                    (betFeedDataTotal[key].betSelectionId === Constants.BET_SELECTION_CORNERS_TEAM_AWAY &&
                        betFeedDataTotal[key].market.jw === Constants.TEAM_AWAY)
                ) {
                    handicap = -handicap;
                }
            }

            payload['bettingPopupData'][key] = {
                uuid: betFeedDataTotal[key].uuid,
                site_ids: siteIds,
                bet_selection_id: betFeedDataTotal[key].betSelectionId,
                bet_type_id: betFeedDataTotal[key].betTypeId,
                market_id: betFeedDataTotal[key].marketId,
                period_type_id: betFeedDataTotal[key].periodTypeId,
                custom_event_id: betFeedDataTotal[key].ceId,
                jollywhere: betFeedDataTotal[key].market.jw === undefined ? null : betFeedDataTotal[key].market.jw,
                is_live: betFeedDataTotal[key].marketId === Constants.DBALL_MARKET_LIVE,
                handicap: handicap,
                correct_score: betFeedDataTotal[key].correctScore,
            };
        });

        return payload;
    },

    async updateUserDataEvent(payload) {
        //need to store it, we will resend it if websocket is reconnected
        store.state.WebSocketModule.userData = payload;

        await store.dispatch('sendObj', {
            event: 'updateUserData',
            data: payload,
        });
    },
};
export default utils;
